// extracted by mini-css-extract-plugin
export var navbarSubLink = "G_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "G_tB d_f0 d_dB";
export var subPageLink = "G_gf d_gf";
export var burger = "G_vH";
export var sublinkSize = "G_vJ";
export var linkSize = "G_vK";
export var Link = "G_s4 z_s4 z_ss z_sN";